import helpers from 'helpers'

const alertRenewalLessOneThirdDays = (renewalData) => {
  if (renewalData?.schedulingDate)
    return `A renovação está agendada para ${helpers.formatters.date(
      renewalData?.schedulingDate,
    )}, com o índice de ${
      renewalData?.lastIndexValue
    }%. Vale lembrar que esse índice pode ser alterado a qualquer momento na opção 'REAJUSTAR O CONTRATO'.`

  if (renewalData?.automatic)
    return 'A renovação do contrato será feita automaticamente.'

  return (
    'A renovação do contrato deve ser feita manualmente e só pode ocorrer enquanto a cobrança ' +
    'deste mês, referente à última parcela do contrato atual, já estiver sido gerada. Isso garante ' +
    'que a cobrança seja gerada com o valor correto.'
  )
}

export default alertRenewalLessOneThirdDays
